const TooltipValueTitle = require('okCharts/TooltipValueTitle');

module.exports = TooltipValueTitle;
